// extracted by mini-css-extract-plugin
export default {"telegram_container":"TelegramCHannel_telegram_container__CjqPJ","telegram_container_body":"TelegramCHannel_telegram_container_body__rBxQn"};